/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../../../store";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import { initialGeoRegion } from "../../../components/helpers";

export const isCreateUserSelector = (state: AppState) => state.admin;

export const selectedGeoRegionSelector = createSelector([(state: AppState) => state.admin.selectedGeoRegion], (selectedGeoRegion) => {
  if (selectedGeoRegion) {
    return selectedGeoRegion;
  }
  return initialGeoRegion;
});

export const selectedGeoRegionIdsSelector = (state: AppState) => state.admin.selectedGeoRegionIds;

export const selectedGeoRegionsSelector = (state: AppState) => state.admin.selectedGeoRegions || [];

export const selectedProfileSelector = createSelector([(state: AppState) => state.admin.selectedProfile], (selectedProfile) => {
  if (selectedProfile) {
    return selectedProfile;
  }
  return null;
});

export const selectedProfilePermissionsSelector = createSelector([(state: AppState) => state.admin.selectedProfile], (profile) => {
  if (profile) {
    return new ProfilePermissions(profile);
  }
  return null;
});

export const severityValueSelector = (state: AppState) => state.admin.severityValue;
export const snmpValueSelector = (state: AppState) => state.admin.snmpValue;
export const emailValueSelector = (state: AppState) => state.admin.emailValue;
export const isCreateSnmpSelector = (state: AppState) => state.admin.isCreateSNMPGroup;
export const selectedSnmpGroupSelector = (state: AppState) => state.admin.selectedSnmpGroup;
export const selectedSnmpAgentSelector = (state: AppState) => state.admin.snmpAgent;
export const isCreateEmailSelector = (state: AppState) => state.admin.isCreateEmailGroup;
export const selectedEmailGroupSelector = (state: AppState) => state.admin.selectedEmailGroup;
export const selectedSmtpEmailSelector = (state: AppState) => state.admin.smtpEmail;
export const systemPropertiesSelector = (state: AppState) => state.admin.systemProperties;
export const accessControlSettingsSelector = (state: AppState) => state.admin.accessControlSettings;
export const selectedTrapSelector = (state: AppState) => state.admin.selectedTrapReceive;
export const groupListSelector = (state: AppState) => state.admin.groupList;
export const snmpEmailGroupsSelector = (state: AppState) => state.admin.snmpEmailGroups;
export const userFileMgmtSelector = (state: AppState) => state.admin.selectedUserFileMgmt;
export const isAddNewUserFileMgmtSelector = (state: AppState) => state.admin.isAddNewUserFileMgmt;
export const currentSiteGroupsSelector = (state: AppState) => state.admin.currentSiteGroups;
export const selectedSyslogReceiverSelector = (state: AppState) => state.admin.selectedSyslogReceiver;
export const selectedTaskTypeSelector = (state: AppState) => state.admin.selectedTaskType;
export const selectedNotifySelector = (state: AppState) => state.admin.selectedNotificationGroup;
export const selectedFileBulkSelector = (state: AppState) => state.admin.selectedBulkFile;
export const failedBulkSelector = (state: AppState) => state.admin.validatedOfflineErrors;
export const successBulkSelector = (state: AppState) => state.admin.successOfflineUploads;
export const dataPollingPropsSelector = (state: AppState) => state.admin.dataPollerProperties;
export const startDateSelector = (state: AppState) => state.admin.startDate;
export const thresholdCrossingSettingProfileModelOpenModeSelector = (state: AppState) => state.admin.thresholdCrossingSettingProfileModelOpenMode;
export const thresholdCrossingSettingActionModelOpenModeSelector = (state: AppState) => state.admin.thresholdCrossingSettingActionModelOpenMode;
export const thresholdCrossingSettingScheduleModelOpenModeSelector = (state: AppState) => state.admin.thresholdCrossingSettingScheduleModelOpenMode;
export const thresholdCrossingSettingRuleModelOpenModeSelector = (state: AppState) => state.admin.thresholdCrossingSettingRuleModelOpenMode;
export const selectedThresholdCrossingSettingProfileSelector = (state: AppState) => state.admin.selectedThresholdCrossingSettingProfile;
export const selectedThresholdCrossingSettingActionSelector = (state: AppState) => state.admin.selectedThresholdCrossingSettingAction;
export const selectedThresholdCrossingSettingScheduleSelector = (state: AppState) => state.admin.selectedThresholdCrossingSettingSchedule;
export const selectedThresholdCrossingSettingRuleSelector = (state: AppState) => state.admin.selectedThresholdCrossingSettingRule;

export const isAddEditDeleteThresholdCrossingSettingProfileSelector = (state: AppState) => state.admin.isThresholdCrossingSettingProfileCrud;
export const isAddEditDeleteThresholdCrossingSettingActionSelector = (state: AppState) => state.admin.isThresholdCrossingSettingActionCrud;
export const isAddEditDeleteThresholdCrossingSettingScheduleSelector = (state: AppState) => state.admin.isThresholdCrossingSettingScheduleCrud;
export const isAddEditDeleteThresholdCrossingSettingRuleSelector = (state: AppState) => state.admin.isThresholdCrossingSettingRuleCrud;


export const showBannerSelector = (state: AppState) => state.admin.showBanner;
export const passwordSettingsSelector = (state: AppState) => state.admin.passwordSettings;
